import { Button } from '../Button/Button';
import { useDispatch } from 'react-redux';
import {
  deleteFile,
  FileUploadState
} from '../../../store/slices/fileUploadSlice';
import { DocumentIcon, TrashCan } from '../../../icons/SvgIcons';

type FileUploadListProps = {
  files: FileUploadState[];
};

export function FileUploadList({ files }: FileUploadListProps) {
  const dispatch = useDispatch();
  const handleDeleteFile = (fileId: string) => {
    dispatch(deleteFile(fileId));
  };

  return (
    <ul className="w-full flex flex-col">
      <li className="flex items-center w-full h-7 mt-4 py-2 px-[21px] text-left text-xs leading-3 text-gray-800 bg-zinc-50">
        Items: {files.length}
      </li>
      {files.map((file, index) => (
        <li
          key={file.id}
          className={`flex gap-0.5 items-center w-full py-3 px-4 text-sm text-zinc-900 leading-[14px] text-left 
            ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
            `}
        >
          <DocumentIcon />
          {file.file.name}
          <Button
            onClick={() => handleDeleteFile(file.id)}
            buttonClassName="ml-auto"
          >
            {TrashCan('large')}
          </Button>
        </li>
      ))}
    </ul>
  );
}
